import createTypes from 'redux-create-action-types';

export const asyncActionTypeRequest = (baseAction) => `${baseAction}_REQUEST`;
export const asyncActionTypeSuccess = (baseAction) => `${baseAction}_SUCCESS`;
export const asyncActionTypeFailure = (baseAction) => `${baseAction}_FAILURE`;

export default createTypes(
  'GET_INSPECTORS',
  'GET_PRODUCT_TAGS',
  'GET_INSPECTION_JOBS',
  'GET_INSPECTION_DRAFT_JOBS',
  'GET_INSPECTION_INSPECTOR_WITH_JOB',
  'GET_BUYER_INSPECTION_DETAIL',
  'GET_INSPECTION_REPORTS',
  'GET_INSPECTION_ATTACHMENTS',
  'CREATE_BUYER_INSPECTION_DOCUMENT',
  'DELETE_BUYER_INSPECTION_ATTACHMENT',
  'GET_INTERNAL_INSPECTION_REPORT_DETAIL',
  'INTERNAL_INSPECTION_ACCEPT',
  'INTERNAL_INSPECTION_REJECT',
  'INSPECTION_JOB_SET_VALIDATE_DATA',
  'INSPECTION_JOB_RESET_VALIDATE_DATA',
  'CREATE_INTERNAL_INSPECTION',
  'UPDATE_INTERNAL_INSPECTION',
  'GET_INSPECTION_3PARTY_SERVICE_PROVIDERS'
);
